var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson")

function AuthInfoWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.antiRoles = ko.observableArray([]);
  self.canChangePassword = ko.observable(true);
  self.name = 'AuthInfoWS';
  self.roles = ko.observableArray([]);
  self.userId = ko.observable('');

	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/employee/authInfo?refresh=true';
  });


	/**
	 * Determines if the user has a specific antirole
	 *
	 * @method hasAntiRole
	 * @param {String} sRole
	 * @returns {Boolean}
	 */
  self.hasAntiRole = function (sRole) {
    var foundRole = self.antiRoles().find(function (role) {
      return role == sRole;
    });

    return (foundRole != null);
  };


	/**
	 * Determines if the user has a specific role
	 *
	 * @method hasRole
	 * @param {String} sRole
	 * @returns {Boolean}
	 */
  self.hasRole = function (sRole) {
    var foundRole = self.roles().find(function (role) {
      return role == sRole;
    });

    return (foundRole != null);
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {AuthInfoWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    var aRoles = [];
    var tRoles = [];

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);
    json = xmlToJson.parse(xmlData);

    if (json.authInfo) {
      if (json.authInfo.canChangePassword === false) {
        self.canChangePassword(false);
      }

      self.userId(json.authInfo.userid);

      // Load the authorized roles
      aRoles = json.authInfo.roles;
      aRoles = Array.isArray(aRoles) ? aRoles : [aRoles];
      aRoles.forEach(function (role) {
        tRoles.push(role);
      });
      self.roles(tRoles);

      //clear the variables
      aRoles = [];
      tRoles = [];

      // Load the Anti roles
      aRoles = json.authInfo.antiRole;
      aRoles = Array.isArray(aRoles) ? aRoles : [aRoles];
      aRoles.forEach(function (role) {
        tRoles.push(role);
      });
      self.antiRoles(tRoles);
    }
    return self;
  };

  return self;
};

AuthInfoWS.prototype = AbstractWS.prototype;
AuthInfoWS.prototype.constructor = AuthInfoWS;

module.exports = AuthInfoWS

